import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const Footer = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.pathname.includes("order")) {
      const footerElement = document.getElementById("footer");
      footerElement.style.marginLeft = "0px";
    }
  }, [location]);
  return (
    <footer id="footer" className="main-footer">
      <div className="float-right d-none d-sm-block">
        <b>Version</b> 1.0.0
      </div>
      <strong>Copyright &copy; 2025</strong>
      All rights reserved.
    </footer>
  );
};

export default Footer;
